module.exports = __webpack_public_path__ + "static/media/img137.d82c92e2.jpg";